import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useApi from '../useApi'; // Assuming this is a custom hook for API calls
import { toast } from 'react-toastify';
import { DataGrid } from '@mui/x-data-grid';


const MasterListItems = ({
    projectId: projectIdProp,
    packageId: packageIdProp,
    groupId: groupIdProp,
    form = true
}) => {
    const { projectId, packageId, groupId } = useParams();
    const [newItemNumber, setNewItemNumber] = useState('');
    const [newDescription, setNewDescription] = useState('');
    const [newQuantity, setNewQuantity] = useState(0);
    const [newUnit, setNewUnit] = useState('');
    const [newNotes, setNewNotes] = useState('');
    const [{ data: items, loading }, callApi] = useApi();

    useEffect(() => {
        callApi({ url: `/api/projects/${projectIdProp || projectId}/packages/${packageIdProp || packageId}/master_list_groups/${groupIdProp || groupId}/master_list_items` });
    }, [projectId, packageId, groupId, callApi, projectIdProp, packageIdProp, groupIdProp]);

    const handleCreateItem = async (e) => {
        e.preventDefault();
        callApi({
            url: `/api/projects/${projectId}/packages/${packageId}/master_list_groups/${groupId}/master_list_items`,
            method: 'POST',
            body: {
                item_number: newItemNumber,
                description: newDescription,
                quantity: newQuantity,
                unit: newUnit,
                notes: newNotes
            }
        })
            .then(() => {
                toast.success("Item created successfully!");
                // Reset form fields
                setNewItemNumber('');
                setNewDescription('');
                setNewQuantity(0);
                setNewUnit('');
                setNewNotes('');
                // Re-fetch items to update the list
                callApi({ url: `/api/projects/${projectId}/packages/${packageId}/master_list_groups/${groupId}/master_list_items` });
            });
    };

    const columns = [
        { field: 'item_number', headerName: 'Item Number', width: 70 },
        { field: 'description', headerName: 'Description', width: 130 },
        { field: 'quantity', headerName: 'Quantity', width: 130 },
        {
            field: 'unit',
            headerName: 'Unit',
            width: 90,
        },
    ];


    const rows = Array.isArray(items) ? items.map(item => (
        { id: item.item_number, item_number: item.item_number, description: item.description, quantity: item.quantity, unit: item.unit }

    )) : [];

    return (
        <div className="content-container">
            <h2>Master List Items for Group {groupId}</h2>
            {loading && <div>Loading...</div>}
            {form && <form onSubmit={handleCreateItem} className="form-container">
                <textarea
                    placeholder="Item Number"
                    value={newItemNumber}
                    onChange={e => setNewItemNumber(e.target.value)}
                    className="form-textarea"
                />
                <textarea
                    placeholder="Description"
                    value={newDescription}
                    onChange={e => setNewDescription(e.target.value)}
                    required
                    className="form-textarea"
                />
                <input
                    type="number"
                    placeholder="Quantity"
                    value={newQuantity}
                    onChange={e => setNewQuantity(parseFloat(e.target.value))}
                    step="0.001" // Allow decimal input with a step of 0.01
                    required
                    className="form-input"
                />
                <textarea
                    placeholder="Unit"
                    value={newUnit}
                    onChange={e => setNewUnit(e.target.value)}
                    required
                    className="form-textarea"
                />
                <textarea
                    placeholder="Notes"
                    value={newNotes}
                    onChange={e => setNewNotes(e.target.value)}
                    className="form-textarea"
                />
                <button type="submit" className="form-button">Create New Item</button>
            </form>}
            <div style={{ height: 400, width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 5 },
                        },
                    }}
                    pageSizeOptions={[5, 10]}
                    checkboxSelection
                />
            </div>

        </div>
    );
};

export default MasterListItems;
